<script lang="ts">
	import { escapeHtml } from '@repo/ui'

	interface Props {
		text: string
	}

	let { text }: Props = $props()

	function formatMarkdown(text: string) {
		let html = escapeHtml(text)

		const bold = /\*\*(.*?)\*\*/gm
		html = html.replace(bold, '<strong>$1</strong>')

		const emphasis = /(?<!\*)\*([^*]+?)\*(?!\*)/gm
		html = html.replace(emphasis, '<em>$1</em>')

		const links = /\[([^\]]+?)\]\(([^)]+?)\)/gm
		html = html.replace(links, '<a href="$2">$1</a>')

		return html
	}

	let formatedText = $derived(formatMarkdown(text))
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
{@html formatedText}
